import { MutationTree } from 'vuex';

import { UserI } from '@/store/auth/state';
import {
  PlansStateI,
  PlansI,
} from './state';

export const mutations: MutationTree<PlansStateI> = {
  setPlans(state: PlansStateI, payload: PlansI[]) {
    state.plans = payload;
  },
  setPlan(state: PlansStateI, payload: PlansI) {
    state.plan = payload;
  },
};
